export default ({ theme }) => ({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '13rem',
    height: '13rem',
    margin: `${theme.imageMap.margin}rem`,
    border: `1px solid ${theme.colors.lightGrey}`,
    borderRadius: '4px',
    verticalAlign: 'middle',
    '& .ant-btn:first-of-type': {
        marginRight: '0.25rem',
    },
    '& .ant-spin.ant-spin-spinning': {
        position: 'absolute',
    },
    ':hover': {
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.09)',
        cursor: 'pointer',
    },
});
